import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './contact-page-panel.scss.js';

class ContactPagePanel extends s {
    constructor() {
        super(...arguments);
        this.convatecData = {
            title: '',
            representatives: [],
        };
        this.representativeSearchResult = [];
        this.enableZipCode = false;
        this.contactPagePanelId = '';
        this.filteredReps = this.convatecData.representatives;
        this.zipCodeFilter = '';
        this.continents = new Set();
        this.countryByContinent = {};
        this.currentPage = 1;
        this.selectedContinent = 'All';
        this.selectedCountry = 'All';
    }
    firstUpdated() {
        this.generateFilters();
        this.filteredReps = [...this.convatecData.representatives];
    }
    updated(changedProperties) {
        if (changedProperties.has('representativeSearchResult') &&
            this.representativeSearchResult.length > 0) {
            this.filteredReps = this.filteredReps.filter(rep => this.representativeSearchResult.some(resut => resut.representativeId === rep.representativeId));
        }
        if (changedProperties.has('selectedCountry')) {
            const selectedCountryDetails = this.getCountryDetails(this.selectedCountry);
            this.enableZipCode = (selectedCountryDetails === null || selectedCountryDetails === void 0 ? void 0 : selectedCountryDetails.enableZipCodes) || false;
        }
    }
    getCountryDetails(targetCountry) {
        for (const representative of this.convatecData.representatives) {
            for (const location of representative.location) {
                if (location.country.toLowerCase() === targetCountry.toLowerCase()) {
                    return {
                        country: location.country,
                        enableZipCodes: location.enableZipCodes,
                    };
                }
            }
        }
        return null;
    }
    generateFilters() {
        const continents = new Set();
        const countryByContinent = {};
        this.convatecData.representatives.forEach(rep => {
            rep.location.forEach(loc => {
                continents.add(loc.continent);
                if (!countryByContinent[loc.continent]) {
                    countryByContinent[loc.continent] = new Set();
                }
                countryByContinent[loc.continent].add(loc.country);
            });
        });
        this.continents = continents;
        this.countryByContinent = countryByContinent;
    }
    updateFilter() {
        this.filteredReps = this.convatecData.representatives;
        if (this.zipCodeFilter && this.zipCodeFilter.length >= 4) {
            this.fetchData(this.zipCodeFilter);
        }
        this.filteredReps = this.filteredReps.filter(rep => rep.location.some(loc => {
            const matchContinent = this.selectedContinent === 'All' ||
                loc.continent === this.selectedContinent;
            const matchCountry = this.selectedCountry === 'All' ||
                loc.country === this.selectedCountry;
            return matchContinent && matchCountry;
        }));
        this.currentPage = 1;
    }
    changePage(page) {
        this.currentPage = page;
    }
    fetchData(zipCode) {
        const url = `/api/ZipCodeSearch?zipCode=${zipCode}&contentId=${this.contactPagePanelId}`;
        fetch(url)
            .then(response => {
            if (response.status === 404) {
                this.filteredReps = [];
                throw new Error('Representatives not found (404)');
            }
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
            .then(data => {
            this.representativeSearchResult = data;
        })
            .catch(err => {
            console.log(err);
        });
    }
    get paginatedReps() {
        const start = (this.currentPage - 1) * 10;
        const end = start + 10;
        return this.filteredReps.slice(start, end);
    }
    render() {
        const totalPages = Math.ceil(this.filteredReps.length / 10);
        return x `<section class="contact-page-panel"><div class="container"><h2>${this.convatecData.title || 'Default Title'}</h2><div class="filters"><h2 style="font-size:1.1rem;font-weight:700">Filter Convatec representatives</h2><div style="display:flex"><div class="form-group"><label for="continent">Continent:</label> <select id="continent" @change="${(e) => {
            this.selectedContinent = e.target.value;
            this.selectedCountry = 'All';
            this.zipCodeFilter = '';
            this.updateFilter();
        }}"><option value="All">All</option>${Array.from(this.continents).map(continent => x `<option value="${continent}">${continent}</option>`)}</select></div><div class="form-group"><label for="country">Country:</label> <select id="country" @change="${(e) => {
            this.selectedCountry = e.target.value;
            this.zipCodeFilter = '';
            this.updateFilter();
        }}"><option value="All" ?selected="${this.selectedCountry === 'All'}">All</option>${this.selectedContinent === 'All'
            ? (() => {
                const allCountries = new Set();
                for (const countries of Object.values(this.countryByContinent)) {
                    countries.forEach(country => allCountries.add(country));
                }
                return Array.from(allCountries).map(country => x `<option value="${country}">${country}</option>`);
            })()
            : Array.from(this.countryByContinent[this.selectedContinent] || []).map(country => x `<option value="${country}">${country}</option>`)}</select></div>${this.enableZipCode
            ? x `<div class="form-group"><label for="zipCode">Zip Code:</label> <input type="text" id="zipCode" class="inputZipCode" placeholder="Please enter a 5 digit ZIP Code" @input="${(e) => {
                this.zipCodeFilter = e.target.value;
                this.updateFilter();
            }}"></div>`
            : null}</div></div><p class="results-count" style="font-weight:700">${this.filteredReps.length} results:</p><ul class="representatives-list">${this.paginatedReps.map(rep => x `<li class="representative"><div class="representative-image"><img src="${rep.image}" alt="${rep.name}"></div><div class="representative-info"><strong>${rep.name}</strong><br>${rep.title}<br>${rep.coverage && rep.coverage !== ''
            ? x `${rep.coverage}<br>`
            : null} <a href="mailto:${rep.email}">${rep.email}</a><br>${rep.location.length > 1 ? 'Countries' : 'Country'}: ${[...new Set(rep.location.map(loc => loc.country))].join(', ')}</div></li>`)}</ul><div class="pagination">${Array.from({ length: totalPages }, (_, i) => i + 1).map(page => x `<button class="btn pagination-button ${this.currentPage === page
            ? 'active'
            : ''}" @click="${() => this.changePage(page)}">${page}</button>`)}</div></div></section>`;
    }
}
ContactPagePanel.styles = css_248z;
__decorate([
    n({ type: Object })
], ContactPagePanel.prototype, "convatecData", void 0);
__decorate([
    n({
        type: Array,
    })
], ContactPagePanel.prototype, "representativeSearchResult", void 0);
__decorate([
    n({ type: Boolean })
], ContactPagePanel.prototype, "enableZipCode", void 0);
__decorate([
    n({ type: String })
], ContactPagePanel.prototype, "contactPagePanelId", void 0);
__decorate([
    n({ type: Array })
], ContactPagePanel.prototype, "filteredReps", void 0);
__decorate([
    n({ type: String })
], ContactPagePanel.prototype, "zipCodeFilter", void 0);
__decorate([
    n({ type: Set })
], ContactPagePanel.prototype, "continents", void 0);
__decorate([
    n({ type: Object })
], ContactPagePanel.prototype, "countryByContinent", void 0);
__decorate([
    n({ type: Number })
], ContactPagePanel.prototype, "currentPage", void 0);
__decorate([
    n({ type: String })
], ContactPagePanel.prototype, "selectedContinent", void 0);
__decorate([
    n({ type: String })
], ContactPagePanel.prototype, "selectedCountry", void 0);
customElements.define('contact-page-panel', ContactPagePanel);

export { ContactPagePanel };
